// Dependencies
import React, { useState, useEffect, useRef, useCallback } from "react";
import { gsap } from 'gsap';

// Components
import Icon from "./icons/";
import SingleArrow from "./icons/singleArrow";
import Check from "./icons/check";

let usersModified = [];

const SelectMultiple = (props) => {
  const [items, setItems] = useState(
    props.itemsSelected !== undefined && props.itemsSelected.length > 0
      ? props.itemsSelected
      : []
  );
  const [showTooltip, setShowTooltip] = useState(false);
  const [inputValue, setInputValue] = useState({});
  const [canEdit, setCanEdit] = useState(false);

  const checkIconButton = useRef(null);
  const editIconButton = useRef(null);
  const containerElement = useRef(null);
  const iconElement = useRef(null);
  const optionsElement = useRef(null);

  useEffect(() => {
    const body = document.querySelector('body');
    // body.style.overflow = 'hidden'
    return () => {
      body.style.overflow = 'visible';
    };
  }, []);

  useEffect(() => {
    if (props.itemsSelected !== undefined) {
      setItems(props.itemsSelected);
    }
  }, [props.itemsSelected]);

  useEffect(() => {
    setItems([]);
  }, [props.options]);

  const _openOptionsModal = useCallback((e) => {
    if (!props.disabled) {
      props.openOptions(e);
      dropdown();
    }
  }, [props.disabled, props.openOptions]);

  const dropdown = useCallback(() => {
    if (!containerElement.current) return;
    
    if (!containerElement.current.classList.contains("open")) {
      optionsElement.current.style.height =
        props.options.filter((item) => item.id !== "").length * 41 +
        32 +
        "px";

      containerElement.current.style.zIndex = 10;
      containerElement.current.classList.add("open");
      iconElement.current.classList.add("rotate");
      if (
        props.options.filter((item) => item.id !== "").length * 41 + 32 >
        217
      ) {
        optionsElement.current.classList.add("scroll");
      }
    } else {
      optionsElement.current.style.height = 0;
      containerElement.current.classList.remove("open");
      iconElement.current.classList.remove("rotate");
      containerElement.current.style.zIndex = 2;
    }
  }, [props.options]);

  const _selectOption = useCallback((e, item, state, keepOpenDropdown) => {
    e.stopPropagation();

    if (props.multiple) {
      let found = state.items.filter((element) => element.value === item.value);
      if (found.length > 0) {
        let allItems = state.items.filter((element) => element.id !== item.id);
        setItems(allItems);
        props.getOptions(allItems);
      } else {
        let newItems = [...state.items, item];
        setItems(newItems);
        props.getOptions(newItems);
      }
    } else {
      props.getOptions({ item });

      !keepOpenDropdown && dropdown();
    }
  }, [props.multiple, props.getOptions, dropdown]);

  const _handleTooltip = useCallback((e) => {
    e.stopPropagation();

    if (showTooltip !== false) {
      let modalContent = document.querySelector(".modal-content");
      if (modalContent) {
        let modalBody = document.querySelector(".modal-body");
        modalBody.style.paddingTop = "0px";
      }
      setShowTooltip(false);
    } else {
      setShowTooltip(true);
      let modalContent = document.querySelector(".modal-content");
      if (modalContent) {
        setTimeout(() => {
          modalPaddingTop();
        }, 0);
      }
    }
  }, [showTooltip]);

  const modalPaddingTop = useCallback(() => {
    let tooltip = document.querySelector(".container-tooltip");
    let wrapperHelper = document.querySelector(".wrapper-helper");
    let containerTooltip = document.querySelector(".container-tooltip");
    let containerTootlipHeight = containerTooltip.offsetHeight + 36;
    let containerTootlipTop = containerTooltip.getBoundingClientRect().y;
    let modalContent = document.querySelector(".modal-content");
    let modalContentTop = modalContent.getBoundingClientRect().y;
    let dif = containerTootlipTop - (modalContentTop + 112);

    if (dif < 0) {
      let difPositive = -dif;
      let modalBody = document.querySelector(".modal-body");
      modalBody.style.paddingTop = `${difPositive}px`;
    }
  }, []);

  const _getLanguageLegible = useCallback((language) => {
    switch (language) {
      case "es-ES":
        return "Español";
      case "en-US":
        return "English";
      default:
        return "English";
    }
  }, []);

  // Option type input
  const _editInput = useCallback((e, item, index) => {
    let button = e.currentTarget;
    let input = button.previousSibling;
    let parent = e.currentTarget.closest('.options-multiple-select');
    let allInputs = [...parent.querySelectorAll('.options-multiple-select__input')];

    allInputs.forEach(input => input.disabled = true);

    input.disabled = false;
    input.focus();

    gsap.to('.js-edit-button', {
      opacity: 0,
      duration: 0.3,
      onComplete: (e) => {
        setInputValue({ value: input.value, index });
        setCanEdit(true);
        gsap.from('.js-check-button', {
          opacity: 0,
          duration: 1,
          onComplete: (e) => {}
        });
      }
    });
  }, []);

  const _inputOnchange = useCallback((e, index) => {
    setInputValue({ index, value: e.target.value });
  }, []);

  const _inputValue = useCallback((item, index) => {
    if (inputValue.index == index) {
      return inputValue.value;
    } else {
      if (usersModified.length > 0) {
        let uid = usersModified.findIndex(user => user.id === item.id);
        if (uid !== -1) {
          return usersModified[uid].value;
        } else {
          return item.value;
        }
      } else {
        return item.value;
      }
    }
  }, [inputValue]);

  const _confirmUserChanged = useCallback((e, item, state) => {
    e.stopPropagation();

    let button = e.currentTarget;
    let input = button.previousSibling;
    input.disabled = true;
    input.blur();

    let newItem = { ...item, value: state.inputValue.value ? state.inputValue.value : item.value };

    if (usersModified.length > 0) {
      let uid = usersModified.findIndex(user => user.id === item.id);
      if (uid !== -1) {
        usersModified[uid] = newItem;
      } else {
        usersModified.push(newItem);
      }
    } else {
      usersModified.push(newItem);
    }

    gsap.to(button, {
      opacity: 0,
      duration: 0.3,
      onComplete: (e) => {
        props.editMirroName(newItem);
        setCanEdit(false);
        gsap.from('.js-edit-button', {
          opacity: 0,
          duration: 1,
          onComplete: (e) => {}
        });
      }
    });
  }, [props.editMirroName]);

  const _optionOnClick = useCallback((e, item) => {
    let currentTarget = e.target;

    if (currentTarget.nodeName === 'DIV') {
      if (usersModified.length > 0) {
        let uid = usersModified.findIndex(user => user.id === item.id);
        if (uid !== -1) {
          setCanEdit(false);
          _selectOption(e, usersModified[uid], { items });
        } else {
          setCanEdit(false);
          _selectOption(e, item, { items });
        }
      } else {
        if (props.disabledOptions && props.disabledOptions.includes(item.id)) {
          return "";
        } else {
          setCanEdit(false);
          _selectOption(e, item, { items });
        }
      }
    }
  }, [props.disabledOptions, items, _selectOption]);

  return (
    <div
      ref={(ref) => props.setRef(ref)}
      className={`wrapper-multiple-select ${props.disabled ? "is-diabled" : ''} ${props.colorGrey ? "grey" : ''} ${props.noBorder ? "no-border" : ''}`}
    >
      <p className="label-multiple-select">
        {props.label && props.label}
        {props.required && <span className="asterisk">*</span>}
      </p>

      <div className={props.hasTooltip ? "has-tooltip" : ""}>
        <div
          ref={(el) => (containerElement.current = el)}
          className="container-multiple-select"
          onClick={(e) => {
            props.options !== undefined &&
              props.options.length > 0 &&
              _openOptionsModal(e);
          }}
        >
          {!props.hasHtml
            ? <p>{props.defaultValue}</p>
            : <p className="text-multiple-select--space-between" dangerouslySetInnerHTML={{ __html: props.defaultValue }}></p>
          }

          {!props.disabled && (
            <div
              ref={(el) => (iconElement.current = el)}
              className="icons-multiple-select"
            >
              <Icon
                className={"icon"}
                noWrapper={true}
                name="SingleArrow"
                orientation="down"
                width="20px"
                height="20px"
              />
            </div>
          )}
        </div>

        <div
          ref={(el) => (optionsElement.current = el)}
          className={`${props.label ? "options-multiple-select" : "options-multiple-select top"} ${props.hasTooltip ? "with-helper" : ""} ${props.optionsNoAbsolute ? "no-absolute" : ""}`}
        >
          {props.options !== undefined &&
            !props.multiple &&
            props.hasInput &&
            props.options.map((item, index) => {
              if (item.value !== "Select") {
                return (
                  <div
                    key={`option_input_${index}`}
                    className='options-multiple-select__input-container'
                    onClick={(e) => _optionOnClick(e, item)}
                  >
                    <input
                      onChange={(e) => _inputOnchange(e, index)}
                      value={_inputValue(item, index)}
                      disabled={true}
                      className={
                        inputValue.index === index &&
                        inputValue.value !== '' &&
                        canEdit
                          ? 'options-multiple-select__input is-active'
                          : 'options-multiple-select__input'
                      }
                    />

                    {inputValue.index === index &&
                      inputValue.value !== '' &&
                      canEdit && (
                        <button
                          ref={checkIconButton}
                          type='button'
                          onClick={(e) => _confirmUserChanged(e, item, { inputValue, items })}
                          className='js-check-button'
                        >
                          <Icon
                            name="Check"
                            color="#408197"
                            className='options-multiple-select__icon'
                            iconBig={false}
                            width={16}
                            height={16}
                          />
                        </button>
                      )}

                    {!canEdit && (
                      <button
                        ref={editIconButton}
                        type='button'
                        onClick={(e) => _editInput(e, item, index)}
                        className='js-edit-button'
                        style={{ zIndex: 99999 }}
                      >
                        <Icon
                          name="Edit"
                          color="#408197"
                          className='options-multiple-select__icon'
                          iconBig={false}
                          width={16}
                          height={16}
                        />
                      </button>
                    )}
                  </div>
                );
              }
            })}

          {props.options !== undefined && !props.hasHtml && !props.hasInput && props.options.map((item, index) => {
            if (item.value !== "Select") {
              return (
                <p
                  key={`option_${index}`}
                  className="option"
                  style={{
                    color:
                      props.disabledOptions &&
                      props.disabledOptions.includes(item.id)
                        ? "gray"
                        : "",
                  }}
                  onClick={(e) =>
                    props.disabledOptions &&
                    props.disabledOptions.includes(item.id)
                      ? ""
                      : _selectOption(e, item, { items })
                  }
                >
                  {props.language
                    ? _getLanguageLegible(item.value)
                    : props.asName ? item[props.asName] : item.value}
                  {items !== undefined &&
                    props.multiple &&
                    items.filter((element) => element.value === item.value).length > 0 && (
                      <Check width={10} height={10} color={"#408197"} />
                    )}
                </p>
              );
            }
          })}

          {props.options !== undefined && props.hasHtml && !props.hasInput && props.options.map((item, index) => {
            if (item.value !== "Select") {
              return (
                <p
                  key={`option_${index}`}
                  className="option"
                  style={{
                    color:
                      props.disabledOptions &&
                      props.disabledOptions.includes(item.id)
                        ? "gray"
                        : "",
                  }}
                  onClick={(e) =>
                    props.disabledOptions &&
                    props.disabledOptions.includes(item.id)
                      ? ""
                      : _selectOption(e, item, { items })
                  }
                  dangerouslySetInnerHTML={{ __html: item.value }}
                >
                </p>
              );
            }
          })}
        </div>

        {props.hasTooltip && (
          <span
            className="wrapper-helper"
            onClick={(e) => _handleTooltip(e)}
          >
            <div className="helper-text">
              <Icon name="InfoTooltip" noWrapper={true} />
            </div>

            {showTooltip && (
              <div
                className="container-tooltip right"
                onClick={(e) => _handleTooltip(e)}
              >
                <span className="tooltip-title">
                  {props.helperTooltip[0]}
                </span>
                <span className="tooltip-text" dangerouslySetInnerHTML={{ __html: props.helperTooltip[1] }}>
                </span>
              </div>
            )}
          </span>
        )}
      </div>

      {/* Error */}
      {props.showErrorLabelNow && props.showErrorLabel && (
        <span className="label error">{props.errorLabel}</span>
      )}
      {/* @Error */}

      {/* Error format */}
      {props.showFormatError && (
        <span className="label error">{props.showFormatErrorLabel}</span>
      )}
      {/* @Error format */}

      {/* Hint */}
      {props.showHint && (
        <span className="label hint">{props.hint}</span>
      )}
      {/* @Hint */}
      {/* specialHint */}
      {props.specialHint && props.specialHint[0] && (
        <div className="hint-special">
          <span className="label label--highlighted" dangerouslySetInnerHTML={{ __html: props.specialHint[1] }}>
          </span>
          <Icon
            name="Close"
            color="white"
            iconBig={false}
            className="wrapper-icon-floatButton small"
            close={false}
            width={5}
            height={5}
          />
        </div>
      )}
      {/* @specialHint */}

    </div>
  );
};

export default SelectMultiple;
